import { createSelector } from 'reselect';
var selectErrorState = function (state) { return state.get('error'); };
export var selectError = createSelector(selectErrorState, function (errorState) { return errorState; });
